module.exports = __webpack_public_path__ + "img/8.6c567806.jpg";